import {
  HEADER_BORDER_BOTTOM,
  OVERLAY_BORDER,
  ROW_BORDER_BOTTOM,
} from '../../constants/borderStyles';
import {DEFAULT_COL_WIDTH} from '../../constants/defaultColWidth';
import {EagColumn} from '../../types/EagColumn';
import {EagColumnState} from '../../types/EagColumnState';
import {RowData} from '../../types/RowData';
import {getValueFromRawCell} from '../../utils/getValueFromRawCell';
import {renderCell} from '../../utils/renderCell';

export type DragOverlayColumnProps = {
  column: EagColumn;
  columnState: EagColumnState;
  rows: RowData[];
};

/**
 * Renders a full-column preview (header + all visible body cells) inside
 * the dnd-kit DragOverlay. This gives the user a visual representation
 * of the entire column being moved, not just the header chip.
 */
export function DragOverlayColumn(props: DragOverlayColumnProps) {
  const width = props.columnState.width ?? DEFAULT_COL_WIDTH;

  return (
    <div
      className="bg-white shadow-lg rounded overflow-hidden pointer-events-none"
      style={{width, maxWidth: width, ...OVERLAY_BORDER}}
    >
      {/* Header */}
      <div
        className="px-2 py-2 text-xs font-semibold text-gray-600 bg-gray-50 h-9 flex items-center truncate select-none"
        style={HEADER_BORDER_BOTTOM}
      >
        {props.column.headerName}
      </div>
      {/* Body cells */}
      {props.rows.map((row) => {
        const rawValue = row[props.column.field];
        const value = getValueFromRawCell(props.column, rawValue);
        return (
          <div
            key={row.id}
            className="px-2 h-[42px] flex items-center overflow-hidden whitespace-nowrap text-ellipsis text-sm"
            style={ROW_BORDER_BOTTOM}
          >
            {renderCell(props.column, value, row)}
          </div>
        );
      })}
    </div>
  );
}
